@if (!isLoading) {
  <div class="question">
    <div class="question-panel">
      <!-- Empty state -->
      @if (emptyState?.empty_state) {
        <div>
          <div class="empty-state empty-state--no-pad empty-state--lg">
            <img src="{{emptyState?.empty_state?.img_path}}" alt="" class="img-fluid mb-20" />
            <p class="mb-20" [innerHTML]="emptyState?.empty_state?.text"></p>
            <div class="empty-state__btns">
              <a href="javascript:;" class="button button--secondary" (click)="openSidesheet()">Get started</a>
            </div>
          </div>
        </div>
      }
      <!-- Device list -->
      @if (!emptyState || !emptyState?.empty_state) {
        <div>
          <div class="form-group">
            <div class="custom-devices">
              @for (item of items; track item; let i = $index) {
                <div class="custom-devices__item">
                  <div class="custom-devices__icon">
                    <!-- <svg class="icon"><use xlink:href="#mobile-phone"></use></svg> -->
                    @if (item.img_path) {
                      <img [src]="item.img_path" alt="Item image" class="icon" />
                    }
                  </div>
                  <div class="custom-devices__title">
                    <span>{{ item.description_1 }}</span>
                  </div>
                  <div class="custom-devices__details">
                    <strong>{{ item.description_2 }}</strong>
                  </div>
                  <!-- <div class="custom-devices__tag" *ngIf="!item.imei">
                  <span class="tag-pill tag-pill--warning">Outstanding</span>
                </div> -->
                <div class="custom-devices__actions">
                  <div class="icon-buttons">
                    <button class="icon-button" (click)="deleteItem(i)" [disabled]="readOnly">
                      <svg class="icon"><use xlink:href="#trash-bin"></use></svg>
                    </button>
                    <button class="icon-button" (click)="openSidesheet(i)" [disabled]="readOnly">
                      <svg class="icon"><use xlink:href="#edit"></use></svg>
                    </button>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
        <div class="form-group mb-0">
          <button class="button-control button-control--tight" (click)="openSidesheet()" [disabled]="readOnly">
            <svg class="icon icon--sm"><use xlink:href="#plus"></use></svg><strong>Add another</strong>
          </button>
        </div>
      </div>
    }
  </div>
</div>
}

<!-- Skeleton -->
@if (isLoading) {
  <div>
    @for (s of [1]; track s) {
      <div class="loading-skeleton">
        <div class="loading-skeleton__inner">
          <div class="loading-skeleton__thumb">
            <div class="loading-skeleton__img"></div>
          </div>
          <div class="loading-skeleton__content">
            <div class="loading-skeleton__title"></div>
            <div class="loading-skeleton__text"></div>
          </div>
        </div>
      </div>
    }
  </div>
}

<app-sidesheet
  #itemSidesheet
  [type]="'item-form'"
  [title]="editingIndex > -1 ? 'Edit item' : side_sheet_title"
  [itemQuestions]="currentItem"
  [editingIndex]="editingIndex"
  (itemSave)="onItemSaved($event)"
  (backClicked)="onBackClicked()">
</app-sidesheet>
